export default {
  blockTitle: {
    id: 'seller-no_access_page-block_title',
    defaultMessage: "You don't have access to this page.",
  },
  blockDescription: {
    id: 'seller-no_access_page-block_description',
    defaultMessage:
      'Contact your admin to request access to this part of the Back Office.',
  },
}
